<template>
  <div class="uploader" :class="{ 'is-disabled': isFull }">
    <NoticeBox type="info" v-if="isFull" class="space-b-3">
      画像登録数の上限に達しました。
    </NoticeBox>
    <input
      type="file"
      multiple
      ref="input"
      @change="onChange"
      accept="image/jpeg, image/png, image/gif"
    />
    <button type="button" class="uploader-control" @click="onSelect">
      写真を選択する
      <i class="far fa-plus-square"></i>
    </button>
    <p class="uploader-note">
      ※登録できる画像は10枚までとなります。<br />
      ※登録できる画像形式はjpg, png, gifです。
    </p>
    <ul class="imagebox-list space-t-2">
      <li
        class="imagebox-list-item"
        v-for="item in images"
        :key="item.key"
      >
        <figure class="imagebox">
          <div class="imagebox-content">
            <img :src="item.imagePath" alt="" />
          </div>
          <figcaption class="imagebox-footer">
            <span class="imagebox-caption">
              {{ item.name }}
            </span>
            <button
              type="button"
              class="imagebox-control"
              @click="onRemove(item.key)"
            >
              <i class="fas fa-times"></i>
            </button>
          </figcaption>
        </figure>
      </li>
    </ul>
  </div>
</template>

<script>
import NoticeBox from '@/components/NoticeBox.vue'
import UploadImage from '@/utils/UploadImage'
import resizeImage from '@/utils/resize-image'
import { TOO_MUCH_UPLOAD, INVALID_IMAGE_TYPE } from '@/messages/errors'

function isValidImageType(fileType) {
  if (!fileType) {
    return false
  }

  return (
    fileType.indexOf('image/jpeg') === 0 ||
    fileType.indexOf('image/png') === 0 ||
    fileType.indexOf('image/gif') === 0
  )
}

export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    maxFiles: {
      type: Number,
      required: false,
      default: 10
    }
  },

  components: {
    NoticeBox
  },

  data() {
    return {
      images: []
    }
  },

  computed: {
    isFull() {
      return this.value.length === this.maxFiles
    }
  },

  methods: {
    onSelect() {
      if (this.isFull) {
        return false
      }

      this.$emit('error', '')

      // clear file input
      const input = this.$refs.input
      input.type = 'text'
      input.type = 'file'

      // ファイル選択ウィンドウを開く
      this.$refs.input.click()
    },
    async onChange(e) {
      if (this.isFull) {
        return false
      }

      const files = e.target.files

      if (!this.validate(files)) {
        return false
      }

      for (const file of files) {
        await this.readFile(file)
      }
    },
    validate(files) {
      if (this.tooMuchImages(files)) {
        this.$emit('error', TOO_MUCH_UPLOAD)
        return false
      }

      if (this.containsInvalidImage(files)) {
        this.$emit('error', INVALID_IMAGE_TYPE)
        return false
      }

      return true
    },
    tooMuchImages(files) {
      return this.value.length + files.length > this.maxFiles
    },
    containsInvalidImage(files) {
      return Array.prototype.some.call(files, f => {
        return !isValidImageType(f.type)
      })
    },
    async readFile(file) {
      const { dataUrl } = await resizeImage(file)

      const newImage = {
        image_name: file.name,
        image_base64: dataUrl
      }

      this.$emit('input', [newImage, ...this.value])
    },
    onRemove(key) {
      const val = this.images
        .filter(img => img.key !== key)
        .map(img => img.getAnswer())

      this.$emit('input', val)
    }
  },

  watch: {
    value: {
      handler(val) {
        this.images = val.map(v => new UploadImage({
          id: v.answer_image_id,
          name: v.image_name,
          base64: v.image_base64,
          signedUrl: v.signed_url
        }))
      },
      immediate: true
    }
  }
}
</script>
